import { ApiUser } from 'api/userEnvironment/types/ApiUserEnvironment';
import { ApiUserEnvironmentOrgMini } from 'api/userEnvironment/types/ApiUserEnvironmentOrgMini';

export function userOwnsListing(
  user: ApiUser | null | undefined,
  orgId?: string,
): ApiUserEnvironmentOrgMini | null | undefined {
  return user && orgId && user.orgs
    ? user.orgs.find((o) => o.id === orgId)
    : undefined;
}
